var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left"},[_c('left-header',{staticClass:"item"}),_c('left-footer',{staticClass:"item"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }